import classNames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export default function CardPhase({ phases_management, isCompleted }: any) {
	const { t } = useTranslation();

	if (isCompleted) {
		return (
			<div className="flex justify-between items-center flex-col bg-[#EBFDF9] border-y gap-1 text-base font-roboto py-2 min-h-[70px] text-primary border-primary">
				<span className="font-bold">Congratulations!</span>
				<span>This project has been successfully completed.</span>
			</div>
		);
	}

	const hasActivePhase = phases_management?.phases_id;

	const title = hasActivePhase ? t('thePhaseIsOpen') : t('noActivePhases');
	// Commented out date range display
	// const description = hasActivePhase
	// 	? `${moment(phases_management?.phases_open).format('DD.MM.YYYY')} - ${moment(
	// 			phases_management?.phases_closed
	// 		).format('DD.MM.YYYY')}`
	// 	: '';
	
	// Empty description instead of date range
	const description = '';

	return (
		<div
			className={classNames(
				'flex justify-between items-center flex-col bg-[#EBFDF9] border-y gap-1 text-base font-roboto py-2 min-h-[70px]',
				{
					'bg-disabled text-light-grey border-light': !hasActivePhase,
					'text-primary border-primary': hasActivePhase,
				}
			)}
		>
			<span className="font-bold mt-3">{title}</span>
			<span>{description}</span>
		</div>
	);
}
